interface NotFoundPageProps {
  message?: string;
}

export function NotFoundPage({
  message = "The page you're looking for doesn't exist.",
}: NotFoundPageProps) {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-foreground mb-2">
          Page Not Found
        </h2>
        <p className="text-muted-foreground mb-6">{message}</p>
        <a
          href="/"
          className="inline-block px-6 py-2 bg-primary text-primary-foreground rounded-md hover:opacity-90 transition-opacity"
        >
          Go Home
        </a>
      </div>
    </div>
  );
}

export function TenantNotFoundPage() {
  return (
    <NotFoundPage message="The booking site you're looking for doesn't exist. Please check the URL and try again." />
  );
}

export default NotFoundPage;
